import { useMemo } from 'react';
import { env } from '@sib/config';
import { Api } from '../api-client';

export const useAgentApi = (aiPort?: string): Api<unknown> => {
  return useMemo(() => {
    const baseURL = `${env.agentApiBaseUrl}${aiPort ? `:${aiPort}` : ''}`;

    return new Api({ baseURL });
  }, [aiPort]);
};
